import React, { Component } from 'react';
import { PreviousButton } from '../components/PreviousButton';
import { LenderRow } from '../components/LenderRow';
import { SingleSvg } from '../svg/SingleSvg';
import { JointSvg } from '../svg/JointSvg';

interface IProps {
    gtmEvent(): void;
    nextStep(s: string): void;
    prevStep(): void;
}

export class SingleOrJoint extends Component<IProps, any> {

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Great! Just a <span className='doddltext'>few more</span> things...</h1>
                <h2 className='l'>Is this a single or joint application?</h2>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='boxty' onClick={() => this.props.nextStep('single')}>
                                <div>
                                    <div><SingleSvg/></div>
                                    <div><span className='b'>It's just me</span></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='boxty' onClick={() => this.props.nextStep('joint')}>
                                <div>
                                    <div><JointSvg /></div>
                                    <div><span className='b'>Joint application</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
